"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OrderTotalsState_1 = require("./OrderTotalsState");
var styles = require("./OrderTotals.scss");
var ui_components_1 = require("@idp/ui-components");
var icons = require("../../../styles/ccc-icons-cart.scss");
var ui_components_2 = require("@idp/ui-components");
var UtilityFunctions_1 = require("../../../utils/UtilityFunctions");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var ui_components_3 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var StateProvider_1 = require("../../../api/StateProvider");
var event_bus_1 = require("@idp/event-bus");
var components_1 = require("@idp/duc/components");
var basePanelOptions = { backgroundColor: '#FFF' };
var OrderTotals = /** @class */ (function (_super) {
    __extends(OrderTotals, _super);
    function OrderTotals(props) {
        var _this = _super.call(this, props) || this;
        _this.lobDisplayOrder = ['WIRELESS', 'BROADBAND', 'ACCESSORY'];
        _this.lobOrderTotalObj = new Array();
        _this.dueTodaySubtotal = 0;
        _this.dueOn1BillSubtotal = 0;
        _this.lobLegalObj = new Array();
        _this.modaltitleText = '';
        _this.respLobList = new Array();
        _this.state = new OrderTotalsState_1.default();
        _this.getOrderTotalData = _this.getOrderTotalData.bind(_this);
        _this.openDueTodayModal = _this.openDueTodayModal.bind(_this);
        _this.closeDueTodayModal = _this.closeDueTodayModal.bind(_this);
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.registerToCheckLegal = _this.registerToCheckLegal.bind(_this);
        _this.checkBundLelegalduetoday = _this.checkBundLelegalduetoday.bind(_this);
        _this.checkBundLelegalduefirstbill = _this.checkBundLelegalduefirstbill.bind(_this);
        _this.displayPriceContainer = _this.displayPriceContainer.bind(_this);
        return _this;
    }
    OrderTotals.prototype.componentDidMount = function () {
        this.id = event_bus_1.ICCEventBusManager.getUUID();
        this.registerToCheckLegal();
        this.getOrderTotalData();
    };
    OrderTotals.prototype.registerToCheckLegal = function () {
        var _this = this;
        var duetodayObserver = {
            eventHandler: function () { _this.checkBundLelegalduetoday(); },
            observerId: this.id,
            serviceName: 'CART:bundLelegalduetoday',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(duetodayObserver);
        var duefirstbillObserver = {
            eventHandler: function () { _this.checkBundLelegalduefirstbill(); },
            observerId: this.id,
            serviceName: 'CART:bundLelegalduefirstbill',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(duefirstbillObserver);
    };
    OrderTotals.prototype.checkBundLelegalduetoday = function () {
        var duetodayObj = this.stateManager.get('CART', 'bundLelegalduetoday');
        if (duetodayObj && Object.entries(duetodayObj).length && !this.state.showDueTodaySeeDetailsLink) {
            this.setState({ showDueTodaySeeDetailsLink: true });
        }
    };
    OrderTotals.prototype.checkBundLelegalduefirstbill = function () {
        var duefirstbillObj = this.stateManager.get('CART', 'bundLelegalduefirstbill');
        if (duefirstbillObj && Object.entries(duefirstbillObj).length && !this.state.showDueFirstBillSeeDetailsLink) {
            this.setState({ showDueFirstBillSeeDetailsLink: true });
        }
    };
    OrderTotals.prototype.getOrderTotalData = function () {
        var _this = this;
        this.payload = UtilityFunctions_1.getCartResp();
        if (this.payload
            && this.payload.metadata && this.payload.metadata.metadata &&
            this.payload.metadata.metadata.lobList &&
            this.payload.metadata.metadata.lobList.length > 0) {
            this.respLobList = this.payload.metadata.metadata.lobList;
            this.lobOrderTotalObj = [];
            this.dueTodaySubtotal = this.payload.orderPriceInfo.dueToday;
            this.dueOn1BillSubtotal = Number(this.payload.orderPriceInfo.dueMonthly) +
                Number(this.payload.orderPriceInfo.dueOneTime);
            this.lobDisplayOrder.forEach(function (lobnameinlist, index) {
                var lobName = lobnameinlist.toLowerCase();
                lobName = lobName.concat('Cart');
                var lobListObj = {
                    lobDue1stBill: 0,
                    lobDueToday: 0,
                    lobNameInlist: '',
                };
                if (_this.payload.metadata.metadata.lobList.indexOf(lobnameinlist) !== -1 &&
                    _this.payload[lobName]) {
                    var tempLobObj = _this.payload[lobName];
                    var lobObj = JSON.parse(JSON.stringify(tempLobObj));
                    lobListObj.lobDue1stBill = Number(lobObj.totalLobDueMonthly) + Number(lobObj.totalLob1stBill);
                    lobListObj.lobDueToday = lobObj.totalLobDueToday;
                    lobListObj.lobNameInlist = String(lobnameinlist);
                    _this.lobOrderTotalObj.push(lobListObj);
                }
            });
            if (this.lobOrderTotalObj.length > 0) {
                this.setState({ showOrderTotal: true });
            }
            else {
                this.setState({ showOrderTotal: false });
            }
        }
    };
    OrderTotals.prototype.openDueTodayModal = function (modaltype) {
        var _this = this;
        this.modaltitleText = '';
        this.lobLegalObj = [];
        var allLegals = {};
        if (modaltype && modaltype === 'showduetoday') {
            allLegals = this.stateManager.get('CART', 'bundLelegalduetoday');
        }
        else if (modaltype && modaltype === 'showduefirstbill') {
            allLegals = this.stateManager.get('CART', 'bundLelegalduefirstbill');
        }
        if (allLegals && Object.entries(allLegals).length) {
            this.lobDisplayOrder.forEach(function (lobnameinlist, index) {
                var lobName = lobnameinlist.toLowerCase();
                var lob = allLegals[lobName];
                if (lob && lob.legalData && _this.respLobList.indexOf(lobName.toUpperCase()) !== -1) {
                    lob.lobName = _this.getLobNameFromCms(lobName, 'modal');
                    lob.legalDuplicateTxt = lobName;
                    _this.modaltitleText = lob.legalData.modaltitle;
                    if (lobName === 'broadband') {
                        lob.legalDuplicateTxt = 'dtvs|broadband';
                        lob.lobName = _this.getLobNameFromCms('dtvs', 'modal') + ' / '
                            + _this.getLobNameFromCms('broadband', 'modal');
                    }
                    _this.lobLegalObj.push(lob);
                }
            });
        }
        if (this.lobLegalObj.length > 0) {
            for (var _i = 0, _a = this.lobLegalObj; _i < _a.length; _i++) {
                var Obj1 = _a[_i];
                for (var Obj2 = 1; Obj2 < this.lobLegalObj.length; Obj2++) {
                    {
                        var legalObj1 = Obj1;
                        var legalObj2 = this.lobLegalObj[Obj2];
                        if (legalObj1 && legalObj1.legalDuplicateTxt && legalObj2 && legalObj2.legalDuplicateTxt &&
                            (legalObj1.legalDuplicateTxt === legalObj2.legalDuplicateTxt)) {
                            this.lobLegalObj.splice(Obj2, 1);
                            break;
                        }
                    }
                }
            }
            this.setState({ showDueTodayModal: true });
        }
    };
    OrderTotals.prototype.closeDueTodayModal = function () {
        this.setState({ showDueTodayModal: false });
    };
    OrderTotals.prototype.render = function () {
        this.cmsContent = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.orderTotals;
        return (React.createElement(ui_components_1.BasePanel, { testId: ui_components_1.BasePanel.name + '_OrderTotalsPanel', options: basePanelOptions },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.planIcon },
                    React.createElement("i", { "aria-label": "Icon", role: "img", className: [styles.iconImg, icons.cccIconCart, icons.cccIconCartPay].join(' ') })),
                React.createElement("div", { className: styles.inlineBlock },
                    React.createElement(ui_components_2.Label, { testId: 'Order Totals Label', data: { text: UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'bundleTotalsTitle') }, options: { className: styles.bundleTitle } }))),
            this.state.showOrderTotal && this.showDueToday(),
            this.state.showOrderTotal && this.showDueFirstBill(),
            this.state.showOrderTotal && this.showLegalModal()));
    };
    OrderTotals.prototype.componentWillUnmount = function () {
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(this.id);
    };
    OrderTotals.prototype.showDueToday = function () {
        return (React.createElement("div", { className: styles.subItems },
            React.createElement("div", { className: styles.title2 },
                React.createElement("span", null, UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'duetodayTitle'))),
            this.displayPriceContainer('DueToday'),
            this.showSubTotal(UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'subtotal'), this.dueTodaySubtotal, 'showduetoday', this.state.showDueTodaySeeDetailsLink)));
    };
    OrderTotals.prototype.displayPriceContainer = function (pricetype) {
        var _this = this;
        this.lobOrderTotalObj.forEach(function (currentLobObj, index) {
            var lobLabel = _this.getLobNameFromCms(currentLobObj.lobNameInlist, 'lob');
            var divkey = pricetype === 'DueToday' ? '_LobDueToday' : '_LobMonthly';
            var testIdkey = pricetype === 'DueToday' ? 'DueTodayPrice' : 'DueMonthlyPrice';
            var lobprice = pricetype === 'DueToday' ? currentLobObj.lobDueToday : currentLobObj.lobDue1stBill;
            return (React.createElement("div", { key: divkey + index, className: styles.lobnamecontainer },
                React.createElement("div", { className: styles.lobItems },
                    React.createElement("div", { tabIndex: 0 },
                        React.createElement(ui_components_2.Label, { data: {
                                isDecodingRequired: false,
                                text: lobLabel,
                            }, options: { className: styles.lobname } })),
                    React.createElement("div", { className: styles.dueLobPrice },
                        React.createElement(ui_components_3.PriceContainer, { testId: testIdkey, data: { billingNote: '', price: lobprice }, options: {
                                className: styles.dueLobPrice,
                                decimalPoints: 2,
                                type: PriceContainerProps_1.PricingType.TILE,
                            } })))));
        });
    };
    OrderTotals.prototype.showDueFirstBill = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.subItems },
                React.createElement("div", { className: styles.solidLine }),
                React.createElement("div", { className: styles.title2 },
                    React.createElement("span", null, UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'dueOn1stbillTitle')),
                    React.createElement("span", { className: styles.due1billLable }, UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'dueOn1stbillLabel'))),
                this.displayPriceContainer('DueMonthly'),
                this.showSubTotal(UtilityFunctions_1.utilCheckCMSContent(this.cmsContent, 'subtotal'), this.dueOn1BillSubtotal, 'showduefirstbill', this.state.showDueFirstBillSeeDetailsLink),
                React.createElement("div", { className: styles.solidLine }))));
    };
    OrderTotals.prototype.showSubTotal = function (lableTxt, amount, modaltype, showLink) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: [styles.lobItems, styles.lobnamecontainer].join(' ') },
                React.createElement("div", null,
                    React.createElement("span", { tabIndex: 0 },
                        React.createElement(ui_components_2.Label, { data: {
                                isDecodingRequired: false,
                                text: lableTxt,
                            }, options: { className: styles.subtotalPrice } })),
                    showLink &&
                        React.createElement("span", null,
                            React.createElement(components_1.Link, { kind: "textPlain", testId: 'Bundle_Link DueToday' + modaltype, className: styles.legalLink, 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () {
                                    _this.openDueTodayModal(modaltype);
                                } }, 'See details'))),
                React.createElement("div", { className: styles.subtotalPrice },
                    React.createElement(ui_components_3.PriceContainer, { testId: 'DueMonthlyPrice', data: { billingNote: '', price: amount }, options: {
                            className: styles.subtotalPrice,
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.TILE,
                        } })))));
    };
    OrderTotals.prototype.getLobNameFromCms = function (lobName, type) {
        if (lobName) {
            if (this.respLobList.indexOf(lobName.toUpperCase()) !== -1) {
                if (type && type === 'modal') {
                    return UtilityFunctions_1.utilCheckCMSContent(this.cmsContent.bundleLobLegalModal, lobName.toLowerCase());
                }
                else {
                    return UtilityFunctions_1.utilCheckCMSContent(this.cmsContent.bundleLobNames, lobName.toLowerCase());
                }
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    OrderTotals.prototype.showLegalModal = function () {
        return (React.createElement(ui_components_2.Modal, { testId: "_Due_Today_Details", options: {
                center: true,
                show: this.state.showDueTodayModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
                tabIndex: 0,
            }, events: { onClose: this.closeDueTodayModal } },
            React.createElement("div", { className: styles.legalContainer },
                React.createElement(ui_components_2.Label, { data: { isDecodingRequired: false, text: this.modaltitleText }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } }),
                this.lobLegalObj.map(function (obj, index) {
                    return (React.createElement("div", { key: '_legal' + index },
                        React.createElement("span", { className: styles.legalModalLobname },
                            " ",
                            obj.lobName,
                            " "),
                        React.createElement("div", { dangerouslySetInnerHTML: {
                                __html: obj.legalData.longtext,
                            } })));
                }))));
    };
    return OrderTotals;
}(React.Component));
exports.default = OrderTotals;
//# sourceMappingURL=OrderTotals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/OrderTotals/OrderTotals.js
// module id = 793
// module chunks = 8